import ForgottenPasswordStep2Form from "./ForgottenPasswordStep2Form";

export default ForgottenPasswordStep2Form;
